import { useTheme } from '@/contexts/ThemeContext';
import { ReactNode } from 'react';

interface ThemedCardProps {
  children: ReactNode;
  className?: string;
  padding?: string;
  noBorder?: boolean;
  hoverable?: boolean;
  onClick?: () => void;
}

export const ThemedCard = ({ 
  children, 
  className = '', 
  padding = 'p-6',
  noBorder = false,
  hoverable = false,
  onClick
}: ThemedCardProps) => {
  const { theme } = useTheme();
  
  const baseClasses = `rounded-lg ${padding} ${noBorder ? '' : 'border'} ${className}`;
  const interactiveClasses = hoverable || onClick ? 'cursor-pointer transition-all' : '';
  
  return (
    <div
      className={`${baseClasses} ${interactiveClasses}`}
      style={{
        backgroundColor: theme.colors.bgCard,
        borderColor: noBorder ? 'transparent' : theme.colors.borderColor
      }}
      onMouseEnter={hoverable || onClick ? (e) => {
        e.currentTarget.style.backgroundColor = theme.colors.bgHover;
      } : undefined}
      onMouseLeave={hoverable || onClick ? (e) => {
        e.currentTarget.style.backgroundColor = theme.colors.bgCard;
      } : undefined}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
